import { Link } from 'react-router-dom';
import { ArrowRight, BadgeCheck } from 'lucide-react';
import { FOUNDER } from '@/lib/founder';

// Homepage founder strip — the human anchor behind the AI. Reinforces the
// expertise-as-moat thesis: capture is commoditized, 25 years of Oracle AP is not.
// (Founder video slots into this block once filmed.)
const FounderStrip = () => {
  return (
    <section aria-labelledby="founder-heading" className="bg-gray-50 border-y border-gray-200">
      <div className="container mx-auto px-4 py-16 max-w-5xl">
        <div className="flex flex-col md:flex-row items-start gap-8">
          <img
            src={FOUNDER.photo}
            alt={FOUNDER.photoAlt}
            width={80}
            height={80}
            loading="lazy"
            className="flex-shrink-0 w-20 h-20 rounded-full object-cover border border-gray-200"
          />
          <div className="flex-1">
            <p className="text-sm font-semibold uppercase tracking-wider text-accent mb-2">
              From the founder
            </p>
            <h2 id="founder-heading" className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Capture is the easy part. The hard part is everything Oracle AP does after it.
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Reading an invoice is a commodity now — Oracle's own document understanding will pull
              the data for you. The value is in everything that happens next: coding to the right
              account and fund, matching, routing to the right approver, and posting into Oracle the
              supported way. That's the work — and it's where EZ Cloud lives.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              EZ Cloud is founder-led by {FOUNDER.name}, who has spent {FOUNDER.yearsOracleAP} years
              inside Oracle accounts payable. When you work with us, the person who has lived in
              Oracle AP for a quarter-century is the same person on your first call and at your
              go-live — not a handoff to a team learning your environment on your time.
            </p>
            <div className="flex items-center gap-1.5 text-sm text-gray-600 mb-5">
              <BadgeCheck className="w-4 h-4 text-accent" aria-hidden />
              Oracle-certified · published on the Oracle Reference Architecture for OCI
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 font-semibold text-primary hover:text-accent transition-colors"
            >
              Meet the founder
              <ArrowRight className="w-4 h-4" aria-hidden />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStrip;
